import dior from '@JohnLewisPartnership/jl-design-system/assets/logos/dior.svg';
import chanel from '@JohnLewisPartnership/jl-design-system/assets/logos/chanel.svg';
import styles from './BrandBanner.module.scss';
import { Breadcrumbs } from '../../utils/types/types';

type Props = {
  banner: string;
};

type BannerDetails = {
  bannerHref: string;
  bannerImage: string;
  bannerAlt: string;
  bannerStyles: string;
};

const getBannerDetails = (banner: string): BannerDetails => {
  switch (banner) {
    case 'dior':
      return {
        bannerHref: '/beauty/dior/c600002684',
        bannerImage: dior,
        bannerAlt: 'DIOR',
        bannerStyles: styles.banner,
      };
    case 'chanel':
      return {
        bannerHref: '/beauty/chanel/c7000370531',
        bannerImage: chanel,
        bannerAlt: 'CHANEL',
        bannerStyles: [styles.banner, styles.chanel].join(' '),
      };
    default:
      return null;
  }
};

export const getBrandBanner = (crumbs?: Breadcrumbs): string => {
  if (!crumbs || crumbs.length < 2) return null;

  if (crumbs[0].displayName === 'Beauty' && crumbs[1].displayName === 'CHANEL')
    return 'chanel';

  if (
    ['Shop by Brand', 'Beauty'].includes(crumbs[0].displayName) &&
    crumbs[1].displayName.toLowerCase() === 'dior'
  ) {
    return 'dior';
  }

  return null;
};

export const BrandBanner = ({ banner }: Props) => {
  if (!banner) return null;

  const bannerDetails = getBannerDetails(banner);

  if (!bannerDetails) return null;

  const { bannerHref, bannerImage, bannerAlt, bannerStyles } = bannerDetails;

  return (
    <aside
      aria-label="Brand Banner"
      data-testid="brand-banner-container"
      className={styles.container}
    >
      {banner === 'chanel' && <div className={styles.chanelStripe} />}
      <a className={bannerStyles} href={bannerHref}>
        <img src={bannerImage} alt={bannerAlt} loading="lazy" />
      </a>
    </aside>
  );
};
